import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UsuarioService } from 'src/app/core/services/usuario/usuario.service';
import { ActivatedRoute, Router } from '@angular/router';
declare var $: any;

@Component({
  selector: 'app-header-component',
  templateUrl: './header-component.component.html',
  styleUrls: ['./header-component.component.scss']
})

export class HeaderComponentComponent implements OnInit {
  @Input() title;
  @Input() estado;
  @Input() score;
  @Input() groupBtn1=false;
  @Input() groupBtn2=false;
  @Input() infoAUX=false;
  arrayIdPds: string[] = [];
  widthInicial = 295;
  options: any;
  html: string;
  @Output() accionDescargar: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() accionModal: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() accionInformacionAux: EventEmitter<boolean> = new EventEmitter<boolean>();
  id_component: string;
  mission_id: string;
  time = 3000;
  rol: any
  mostrarBotonDescargarPDF=false;
  constructor(public snackBar: MatSnackBar, private router: Router, private routerActivated: ActivatedRoute, private usuarioServices: UsuarioService) {
    this.id_component = this.routerActivated.snapshot.params['id_componente'];
    this.mission_id = this.routerActivated.snapshot.params['mission_Id'];
    this.rol = this.usuarioServices.getRoles();
  
  }
  ngOnInit(): void {
    $('.ui.dropdown').dropdown();

  }
  ngAfterViewInit(): void {
    if(this.usuarioServices.isRoles(['Jefe de Análisis de Condición','Evaluador Tec.Planta'])){
      this.mostrarBotonDescargarPDF=true;
    }else{
      this.mostrarBotonDescargarPDF=(this.estado=="Finalizado");
    }
    

    $('.ui.dropdown').dropdown();
  }
  openModal(): void {
    this.accionModal.emit(true);
  }
  openModalInformacionAux(){
    this.accionInformacionAux.emit(true);

  }
  copyURL() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = document.location.href;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.mensaje('Link copiado!', '')
  }

  descargarPDF() {
    this.accionDescargar.emit(true);
    $('.dropdown.icon').hide();
    $('.title').addClass('active')
    $('.content').addClass('active')
    $("#spinner").css("display", "block");
    $('.no-pdf').addClass('none');
    $('.no-pdf-flex').addClass('none');
    $('.no-pdf-cell').addClass('none');
    $('.content.active > .container-panel').addClass('transition visible')
    
    setTimeout(() => {

      this.html = (document.getElementById("DATA-PDF").innerHTML);
      this.html = this.html.replace('styled accordion', '')
      this.usuarioServices.generarPDF2(this.html, "type", this.estado, this.score).subscribe(data => {
        this.accionDescargar.emit(false);
        $('.dropdown.icon').show();
        $("#spinner").css("display", "none");
        $('.no-pdf').removeClass('none');
        $('.no-pdf-flex').removeClass('none');
        $('.no-pdf-cell').removeClass('none');
        $('.title').removeClass('active')
        $('.content').removeClass('active')
        this.mensaje('PDF listo!', '');
        this.downloadFile(data.body, this.title + '.pdf')
      });
    }, this.time);

  }
  downloadFile(blob, fileName) {
    const link = document.createElement('a');
    this.blobToBase64(blob, (base64) => {
      link.href = base64;
      link.download = fileName;
      link.click();
      window.close()

    });
  };

  blobToBase64(blob, callback) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64 = reader.result;
      callback(base64);
    };
    reader.readAsDataURL(blob);

  };


  mensaje(message, action) {
    this.snackBar.open(message, action, {
      duration: 6500,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['gray-snackbar'],
    });
  }

}


